import React, { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  MenuItem,
  Button,
  Paper,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

const HomePage = () => {
  const [topic, setTopic] = useState("");       // "" = כל הנושאים
  const [difficulty, setDifficulty] = useState(""); // "" = כל הרמות
  const navigate = useNavigate();

  const normalize = (v) => (v === "" ? null : v);

const handleStart = () => {
  const topicParam = topic === "" ? null : topic;
  const difficultyParam = difficulty === "" ? null : Number(difficulty);
 


  navigate("/quiz", { state: { topic: topicParam, difficulty: difficultyParam } });
};


  return (
    <Box
      dir="RTL"
      sx={{
        minHeight: "75dvh",
        backgroundImage: "url('/bg-badook.png')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        px: 1,
        textAlign: "right", // טקסט מיושר לשמאל
      }}
    >
      <Paper
        elevation={6}
        sx={{
          p: 3,
          maxWidth: 300,
          width: "100%",
          bgcolor: "rgba(255,255,255,0.9)",
          borderRadius: 3,
          textAlign: "left",
          backdropFilter: "blur(4px)",
          direction: "rtl",
        }}
      >
        <Typography variant="h4" gutterBottom sx={{ fontFamily: "Heebo" }}>
          ברוך הבא למדיטסט
        </Typography>
        <Typography variant="subtitle1" gutterBottom>
          אפליקציית תרגול לחובשים
        </Typography>

              <TextField
          select
          fullWidth
          label="נושא"
          value={topic}
          onChange={(e) => setTopic(e.target.value)}
          margin="normal"
          // יישור הערך המוצג בתוך ה-TextField עצמו
          sx={{ "& .MuiSelect-select": { textAlign: "left" } }}
          // שליטה על תפריט ה-dropdown
          SelectProps={{
            MenuProps: {
              PaperProps: {
                sx: { direction: "rtl" } // הופך את התפריט ל-RTL
              },
              MenuListProps: {
                sx: { textAlign: "right" } // מיישר את הטקסט בפריטים לימין
              }
            }
          }}
        >
          {/* כדי לדחוף את התוכן ממש לקצה הימני */}
          {/* <MenuItem value="" sx={{ justifyContent: "flex-end" }}>בחר נושא</MenuItem> */}
          <MenuItem value="cpr" sx={{ justifyContent: "flex-end" }}>החייאה</MenuItem>
          <MenuItem value="trauma" sx={{ justifyContent: "flex-end" }}>טראומה</MenuItem>
          <MenuItem value="anatomy" sx={{ justifyContent: "flex-end" }}>אנטומיה</MenuItem>
          <MenuItem value="emergency" sx={{ justifyContent: "flex-end" }}>חירום שבשגרה</MenuItem>
          <MenuItem value="authority" sx={{ justifyContent: "flex-end" }}>סמכויות החובש</MenuItem>
        </TextField>

       <TextField
          select
          fullWidth
          label="רמת קושי"
          value={difficulty}
          onChange={(e) => setDifficulty(e.target.value)}
          margin="normal"
          sx={{ "& .MuiSelect-select": { textAlign: "left" } }}
          SelectProps={{
            MenuProps: {
              PaperProps: {
                sx: { direction: "rtl", textAlign: "right" }
              },
              MenuListProps: {
                sx: { textAlign: "right" }
              }
            }
          }}
        >
          {/* <MenuItem value="" sx={{ justifyContent: "flex-end" }}>בחר רמה</MenuItem> */}
          <MenuItem value="1" sx={{ justifyContent: "flex-end" }}>קל</MenuItem>
          <MenuItem value="2" sx={{ justifyContent: "flex-end" }}>בינוני</MenuItem>
          <MenuItem value="3" sx={{ justifyContent: "flex-end" }}>קשה</MenuItem>
        </TextField>


        <Button variant="contained" fullWidth sx={{ mt: 3 }} onClick={handleStart}>
          התחל מבחן
        </Button>
      </Paper>
    </Box>
  );
};

export default HomePage;
